import React, { useEffect, useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';
 
const initialValues = {
    title: ''
};

const validationSchema = Yup.object({
    title: Yup.string()
        .required('این فیلد الزامی است..')
        .min(2, "تعداد حروف کم است  ")
        .max(50, "تعداد حروف زیاد است ")
});


const Create = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const { readDataById } = useEntityCrud('OpinionFactor/get');
    const { updateDate } = useEntityCrud("OpinionFactor/Update")

    useEffect((e) => {
         
        readDataById(id).then(({ data }) => {
             
            if (data.status)
                formik.setValues({
                    ...data.result
                });
        });
    }, []);
 
    const onSubmit = (values) => {
         
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            "title": values.title,
            "status": true 
        };
        updateDate({ ...postedData, id }).then(({ data }) => {
             
            if (data.status) {
                toast.success('به روزرسانی معیار با موفقیت انجام شد');
                return navigate('/surveyCriterias');
            } else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/surveyCriterias', { replace: true });
    }


    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش معیار  </div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik}  />
            </div>
        </div>
    );
}

export default Create;